import React from 'react';
import SvgIcon, {SvgIconProps} from '@material-ui/core/SvgIcon';
import {AccentColorOptions, useAccentColorStyle} from 'epic-ue-theme';

/**
 * This component takes the Mat-UI SvgIcon component and extends the color prop to allow for the UE accent colors
 *
 * Material UI documentation for Icons here: https://material-ui.com/components/icons/#material-icons
 */
export type SvgIconColor =
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'action'
    | 'disabled'
    | 'error'
    | undefined;
export type SvgIconPropsNoColor = Omit<SvgIconProps, 'color'>;
export interface AccentProps extends SvgIconPropsNoColor {
    color?: AccentColorOptions;
}

export type AccentedSvgIconProps = AccentProps | SvgIconProps;

export const AccentedSvgIcon = (props: AccentedSvgIconProps): JSX.Element => {
    const accentColor = props.color as AccentColorOptions;
    const {style, validAccentColor} = useAccentColorStyle(accentColor);

    /**
     * If a valid accent color is passed then we can reset the color prop into the Material Icon component.
     * The style prop will contain the color override for the accented color.
     */
    const color = validAccentColor ? 'inherit' : (props.color as SvgIconColor);

    const svgIconProps = props as SvgIconProps;
    return <SvgIcon {...svgIconProps} style={style} color={color || 'inherit'} />;
};
